// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__29i8_","prompt":"styles_prompt__3wOED","positive":"styles_positive__3ccrZ","negative":"styles_negative__5q0E6"};